import debounce from "debounce";
export default class CaseStudyFilters {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError("Invalid element");
    }

    this.element = element;
    this.fields = Array.from(element.querySelectorAll("select") ?? []);
    console.log(this.fields);
    this.init();
  }

  submit() {
    const url = new URL(this.element.dataset.url);
    this.fields.forEach(field => {
      if (field.value !== "" && field.value !== "all") {
        url.searchParams.set(field.name, field.value);
      } else {
        url.searchParams.delete(field.name);
      }
    })
    window.location.href = url.toString();
  }

  handleInputChange() {
    debounce(this.submit(), 300);
  }

  init() {
    this.fields.forEach((field) => {
      field.addEventListener("change", this.handleInputChange.bind(this));
    })
  }
}
